if (!customElements.get('product-questions-modal') && !customElements.get('product-questions-tab')) {
  const TIME_THRESHOLD_MS = 5000;

  class ProductQuestionsModal extends ModalDialog {
    show(opener) {
      super.show(opener);

      const formContainer = this.querySelector('div.product-questions-modal__form-container');
      formContainer.innerHTML = this.querySelector('#FormTemplate').innerHTML;

      const form = formContainer.querySelector('form');
      form.addEventListener('submit', e => {
        e.preventDefault();
        e.stopPropagation();

        const input = this.querySelector('input[name="contact[XName]"]');
        const ts = (parseFloat(input.getAttribute('data-ts')) * 1000 + TIME_THRESHOLD_MS) || Number.MAX_VALUE;
        if (input.value.trim() || ts > Date.now()) {
          return;
        }

        fetch(form.getAttribute('action'), {
          method: form.getAttribute('method'),
          body: new FormData(form)
        })
          .then(response => {
            console.log('>>> RESPONSE', response);
            if (response.ok) {
              formContainer.innerHTML = this.querySelector('#SuccessTemplate').innerHTML;
            } else {

            }
          })
          .catch(err => {
            console.error(err);
          });
      }, true);

      form.querySelector('input[autofocus]').focus();
    }
  }

  customElements.define('product-questions-modal', ProductQuestionsModal);

  class ProductQuestionsTab extends HTMLElement {
    constructor() {
      super();
      this.querySelector('details').addEventListener('click', e => {
        e.preventDefault();
        const modal = document.getElementById('ProductQuestionsModal');
        if (modal) {
          if (modal.hasAttribute('open')) {
            modal.hide();
          } else {
            modal.show();
          }
        }
      });
    }
  }

  customElements.define('product-questions-tab', ProductQuestionsTab);
}
